import ReactDOM from 'react-dom/client';
import { PublicApp } from '../../Apps/V1/Public/PublicApp';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<PublicApp />);
